// extracted by mini-css-extract-plugin
export default {"favorite-button":"card-favorite-buttons_favorite-button__WntYL","active":"card-favorite-buttons_active__cwmQf"};